<template>
  <div class="crud_form_wrapper app_settings_class">
    <!-- Start:: Single Step Form Content -->
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #f7941e">{{ $t("SIDENAV.settings.general") }}</h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #f7941e">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Tax Percentage -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.tax_percentage')"
            v-model.trim="data.tax"
            required
            min="0"
            max="100"
          >
            <template #suffix>
              <span style="color: var(--main_theme_clr); font-weight: 600">%</span>
            </template>
          </base-input>
          <!-- End:: Tax Percentage -->

          <!-- Start:: Free Trial Days -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.free_trial_days')"
            v-model.trim="data.free_trail_days"
            required
            min="1"
          />
          <!-- End:: Free Trial Days -->

          <!-- Start:: User Subscription Price -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.user_subscription_price')"
            v-model.trim="data.user_subscription_price"
            required
            min="0"
            step="0.01"
          >
            <template #suffix>
              <span style="color: var(--main_theme_clr); font-weight: 600">{{ $t('PLACEHOLDERS.sar') }}</span>
            </template>
          </base-input>
          <!-- End:: User Subscription Price -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppSetting",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        tax: null,
        free_trail_days: null,
        user_subscription_price: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=general-settings`,
        });
        console.log("DATA =>", res.data.data);
        const settings = res.data.data.data[0]?.value;

        this.data.tax = settings.tax;
        this.data.free_trail_days = settings.free_trail_days;
        this.data.user_subscription_price = settings.user_subscription_price;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "general-settings");

      if (this.data.tax !== null && this.data.tax !== undefined) {
        REQUEST_DATA.append("value[tax]", this.data.tax);
      }

      if (this.data.free_trail_days) {
        REQUEST_DATA.append("value[free_trail_days]", this.data.free_trail_days);
      }

      if (this.data.user_subscription_price !== null && this.data.user_subscription_price !== undefined) {
        REQUEST_DATA.append("value[user_subscription_price]", this.data.user_subscription_price);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: Validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
.app_settings_class form .input_wrapper.top_label .form-label {
  font-size: 14px !important;
  top: -10px !important;
}
@media (max-width: 1080px) {
  .app_settings_class form .input_wrapper.top_label .form-label {
    font-size: 13px !important;
    top: -10px !important;
  }
  .app_settings_class form .input_wrapper.top_label input,
  .app_settings_class
    form
    .input_wrapper.top_label.select_wrapper
    .multiselect
    .multiselect__tags {
    padding: 30px 12px !important;
  }
}
</style>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
